import { c as _c } from "react/compiler-runtime";
import type { SpartanProductCustomizeColorListProps } from '@/app/lcv/components/sections/spartan/products/customize/configurator/color-list/types';
import { getSpartanCustomizeColorHex, getSpartanCustomizeColorName, getSpartanCustomizeColorSwatchBackground } from '@/app/lcv/components/sections/spartan/products/customize/configurator/color-list/utils';
import { getSpartanCustomizeColorFallbackLabel } from '@/app/lcv/components/sections/spartan/products/customize/constants';
import { SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA, SPARTAN_PRODUCT_CUSTOMIZE_TRACKING } from '@/app/lcv/components/sections/spartan/products/customize/tracking';
import type { SpartanCustomizeModelColor } from '@/app/lcv/components/sections/spartan/products/customize/types';
import { SPARTAN_PRODUCT_OUTLINE_NONE_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import { SPARTAN_PRODUCTS_EVENT_NAME } from '@/app/lcv/components/sections/spartan/products/shared/tracking';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { safeCall } from '@/app/utils/safeCall';
export const SpartanProductCustomizeColorList = t0 => {
  const $ = _c(25);
  const {
    theme: t1,
    colors,
    selectedColor,
    onSelectColor,
    onPrepareColorPreview,
    twoToneSolidColor,
    className
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  const isDark = theme === "dark";
  let t2;
  if ($[0] !== onPrepareColorPreview) {
    t2 = color => {
      safeCall(onPrepareColorPreview, color);
    };
    $[0] = onPrepareColorPreview;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handlePrepareColor = t2;
  let t3;
  if ($[2] !== handlePrepareColor || $[3] !== onSelectColor || $[4] !== selectedColor?.documentId) {
    t3 = color_0 => {
      if (color_0.documentId === selectedColor?.documentId) {
        return;
      }
      handlePrepareColor(color_0);
      onSelectColor(color_0);
    };
    $[2] = handlePrepareColor;
    $[3] = onSelectColor;
    $[4] = selectedColor?.documentId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSelectColor = t3;
  let t4;
  if ($[6] !== className) {
    t4 = cn("flex flex-wrap items-center justify-center gap-3", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorSwatches
    });
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== colors || $[10] !== handlePrepareColor || $[11] !== handleSelectColor || $[12] !== isDark || $[13] !== selectedColor?.documentId || $[14] !== twoToneSolidColor) {
    let t7;
    if ($[16] !== handlePrepareColor || $[17] !== handleSelectColor || $[18] !== isDark || $[19] !== selectedColor?.documentId || $[20] !== twoToneSolidColor) {
      t7 = (color_1, index) => {
        const hex = getSpartanCustomizeColorHex(color_1);
        if (!hex) {
          return null;
        }
        const colorName = getSpartanCustomizeColorName(color_1);
        const isSelected = color_1.documentId === selectedColor?.documentId;
        return <li key={color_1.documentId} className="size-12 shrink-0 leading-none"><button type="button" aria-label={colorName || getSpartanCustomizeColorFallbackLabel(index)} aria-pressed={isSelected} className={cn("block size-full overflow-hidden rounded-md border-2 p-0.5 transition-[border-color] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] focus-visible:outline-2 focus-visible:outline-offset-2 motion-reduce:transition-none", SPARTAN_PRODUCT_OUTLINE_NONE_CLASS_NAME, isDark ? "focus-visible:outline-white" : "focus-visible:outline-gray-800", isSelected ? isDark ? "cursor-default border-white" : "cursor-default border-gray-800" : isDark ? "cursor-pointer border-transparent hover:border-white focus-visible:border-white" : "cursor-pointer border-transparent hover:border-gray-800 focus-visible:border-gray-800")} onClick={() => handleSelectColor(color_1)} onFocus={() => handlePrepareColor(color_1)} onPointerEnter={() => handlePrepareColor(color_1)} {...createDataAttributes({
            test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorItem(index),
            active: isSelected ? "true" : null
          })} {...createDataGA({
            eventName: SPARTAN_PRODUCTS_EVENT_NAME,
            group: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.section,
            click: true,
            text: colorName,
            value: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.color
          })}><span aria-hidden="true" className="block size-full rounded-sm shadow-[inset_0_0_0_1px_rgba(15,23,42,0.12)]" style={{
              background: getSpartanCustomizeColorSwatchBackground(hex, twoToneSolidColor)
            }} /></button></li>;
      };
      $[16] = handlePrepareColor;
      $[17] = handleSelectColor;
      $[18] = isDark;
      $[19] = selectedColor?.documentId;
      $[20] = twoToneSolidColor;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    t6 = colors.map(t7);
    $[9] = colors;
    $[10] = handlePrepareColor;
    $[11] = handleSelectColor;
    $[12] = isDark;
    $[13] = selectedColor?.documentId;
    $[14] = twoToneSolidColor;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[22] !== t4 || $[23] !== t6) {
    t7 = <ul className={t4} {...t5}>{t6}</ul>;
    $[22] = t4;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};